<template>
    <div class="px-3 px-md-2 pt-3 pt-md-2 pb-1">

      <div v-if="loading" class="text-center py-3">
        <i class="fas fa-spinner fa-spin fa-2x"></i>
      </div>

      <div v-else>

      <p v-if="visitors.length == 0" class="pt-1 text-center">Visitors will show here</p>

        <div v-else class="pt-1">

          <div class="text-center pb-3">
          <small><i :class="`fas ${loadIcon} mr-2`"></i><a href="#/" @click="switchVisitors">Show {{showText}}</a></small>
          </div>

          <!-- Desktop -->
          <table class="table datatables-basic d-none d-md-table">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="15%">Source</th>
                  <th class="pl-3" width="18%">Visitor IP</th>
                  <th class="px-3 text-center" width="10%">Browser</th>
                  <th class="pl-3" width="27%">Page visited</th>
                  <th v-if="!isbot" class="pl-3" width="15%">Country</th>
                  <th class="first-right pl-3" width="15%">When</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(visitor, index) in displayedVisitors" :key="index.id">
              <td class="pl-3">
                <div v-if="visitor.referrer">
                  <i class="fas fa-link mr-2"></i>
                  <a :href="visitor.referrer" target="_blank">{{getDomain(visitor.referrer)}}</a>
                  <div class="pl-4 light-text"><small>{{truncate(getPath(visitor.referrer))}}</small></div>
                </div>
                <div v-else><i class="fas fa-play mr-2"></i>{{getDomain(visitor.referrer)}}</div>
              </td>
              <td class="pl-3">
                <a :href="'http://ip-api.com/json/'+visitor.ip" target="_blank" class="iplink">{{visitor.ip}}</a>
                <small><a href="#/" class="ml-1" @click="updateSearch(visitor.ip)"><i class="fas fa-search"></i></a></small>
              </td>
              <td class="agent"><span :title="visitor.agent"><i :class="visitor.agentLogo+' fa-1x agentLogo'"></i></span></td>
              <td class="pl-3">
                <a :href="visitor.url" target="_blank">{{visitor.title}}</a>
                <div class="light-text"><small>{{truncate(removeDomain(visitor.url))}}</small></div>
                </td>
              <td v-if="!isbot" class="pl-3">
                <img v-if="showFlags && visitor.countryCode" :src="`https://cdn.jsdelivr.net/npm/flag-icons/flags/4x3/${visitor.countryCode}.svg`" width="15" class="mr-1">
                {{visitor.country}}
                <div v-if="visitor.city != 'Bot'" class="light-text"><small>{{visitor.city}}</small></div>
              </td>
              <td class="text-nowrap pl-3">
                <div :title="formatDateMoment(visitor.created_at, timezone)">
                  {{ timeAgo(visitor.created_at, timezone) }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Page • IP • Country</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(visitor, index) in displayedVisitors" :key="index">
  
        <td class="pl-2">
            <div><a :href="visitor.url" target="_blank">{{visitor.title}}</a></div>
            <div class="light-text"><small>{{truncate(removeDomain(visitor.url))}}</small></div>
            <div>
              <a :href="'http://ip-api.com/json/'+visitor.ip" target="_blank" class="iplink">{{visitor.ip}}</a>
              <small><a href="#/" class="ml-1" @click="updateSearch(visitor.ip)"><i class="fas fa-search"></i></a></small>
              </div>
            <div v-if="!isbot"><img v-if="showFlags && visitor.countryCode" :src="`https://cdn.jsdelivr.net/npm/flag-icons/flags/4x3/${visitor.countryCode}.svg`" width="15" class="mr-1">
                {{visitor.country}}<span v-if="visitor.city != 'Bot'" class="light-text ml-3"><small>{{visitor.city}}</small></span>
            </div>
            <div :title="formatDateMoment(visitor.created_at, timezone)">
              {{ timeAgo(visitor.created_at, timezone) }}
            </div>
        </td>

            </tr>
          </tbody>
        </table>

        </div>
</div>

  </div>
</template> 

<script>
export default {
  props: ['isbot', 'site_id', 'search_term'],

  data() {
    return {
      showFlags: true,
      visitors: [],
      timezone: null,
      tabIndex: 0,
      loading: true,
      visitorLimit: 5,
      showAll: false,
      mySearchTerm: this.search_term,
    };
  },

  watch: {
    mySearchTerm: function (val) {
      this.getVisitors();
    },
    search_term: function (newTerm) {
      this.mySearchTerm = newTerm;
      this.getVisitors();
    }
  },

  created() {
    this.getVisitors();

    Echo.channel("site_" + this.site_id)
      .listen("SiteVisitor", () => {
        this.getVisitors();
      });
  },

  computed: {
    displayedVisitors() {
      return this.showAll ? this.visitors : this.visitors.slice(0, this.visitorLimit);
    },

    showText() {
      return this.showAll ? 'less' : 'more';
    },

    loadIcon() {
      return this.showAll ? 'fa-chevron-up' : 'fa-chevron-down';
    },
  },

  methods: {
    updateSearch(newSearchTerm) {
      this.mySearchTerm = newSearchTerm;
      this.$emit('update-search', newSearchTerm);
      window.scrollTo(0, 0);
    },

    switchVisitors() {
      this.showAll = !this.showAll;
    },

    getVisitors() {
      axios.post('/websites/visitors', {
        isbot: this.isbot,
        site_id: this.site_id,
        search_term: this.mySearchTerm,
      })
      .then((response) => {
        this.visitors = response.data.visitors;
        this.timezone = response.data.timezone;
        this.loading = false;
      })
      .catch((error) => {
        console.error('Error fetching visitors:', error);
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
a.iplink { font-weight:normal !important; }
.agentLogo { position: relative; top: 0px;}
td.agent { text-align: center; width:70px; }
</style>